import React, { FC } from "react";
import Modal, { ModalController } from "Components/Modal/Modal";
import { useTranslation } from "Providers/TranslationProvider";
import { DialogContent, Button } from "@material-ui/core";
import { useAuth } from "./AuthProvider";
import ModalTitle from "Components/Modal/ModalTitle";

interface Props {
  modalController: ModalController<unknown>;
}

const AuthSignOutModal: FC<Props> = (props) => {
  const { t } = useTranslation();
  const auth = useAuth();

  if (props.modalController.isOpen) {
    return (
      <Modal
        // pagePath={TrackingPage.AUTH_SIGN_OUT}
        modalController={props.modalController}
      >
        <ModalTitle
          close={props.modalController.close}
          title={t("AuthSignOutModal_Title")}
        >
          <Button
            variant="contained"
            onClick={auth.signOut}
            color="primary"
            disableElevation
          >
            {t("Common_Yes")}
          </Button>
        </ModalTitle>
        <DialogContent>{t("AuthSignOutModal_Description")}</DialogContent>
      </Modal>
    );
  } else {
    return null;
  }
};

export default AuthSignOutModal;
